import { To } from 'react-router-dom';

import { PathName } from './paths';

export const buildSelectPrescriptionsTarget = (surveyId: string): To => ({
  pathname: PathName.SelectPrescriptions,
  search: `surveyId=${surveyId}`
});

/**
 * Destination for "open this renewal": the prescription-selection screen when the renewal survey
 * id is known, the legacy orderId-keyed page otherwise. Every renewal entry point (banner, deep
 * links, appointment flows, the prescriptions list) shares this so they cannot drift apart.
 */
export const buildRenewalTarget = ({
  orderId,
  surveyId,
  type
}: {
  orderId?: string | null;
  surveyId?: string | null;
  type: string;
}): To =>
  surveyId
    ? buildSelectPrescriptionsTarget(surveyId)
    : {
        pathname: PathName.Prescriptions,
        search: `orderId=${orderId}&type=${type}`
      };
